import type { Language, Translation } from '../index';

export const pt = {
  common: {
    save: 'Salvar',
    cancel: 'Cancelar',
    delete: 'Excluir',
    edit: 'Editar',
    add: 'Adicionar',
    loading: 'Carregando...',
    error: 'Ocorreu um erro',
    success: 'Sucesso'
  },
  cookies: {
    notice: 'Utilizamos cookies para melhorar sua experiência',
    description: 'Utilizamos cookies essenciais para fazer este site funcionar. Você pode habilitar cookies adicionais para personalizar sua experiência.',
    essential: 'Apenas essenciais',
    accept: 'Aceitar todos'
  },
  auth: {
    signIn: 'Entrar',
    signUp: 'Cadastrar',
    signOut: 'Sair',
    email: 'Email',
    password: 'Senha',
    forgotPassword: 'Esqueceu a senha?',
    resetPassword: 'Redefinir senha'
  },
  chat: {
    inputPlaceholder: 'Digite sua mensagem...',
    welcomeMessage: 'Olá! Como posso ajudar você hoje?',
    sendMessage: 'Enviar',
    typing: 'Digitando...'
  },
  settings: {
    general: 'Geral',
    design: 'Design',
    ai: 'Configurações de IA',
    miniApps: 'Mini Apps',
    profile: 'Perfil',
    widget: 'Widget'
  },
  miniApps: {
    products: {
      title: 'Produtos',
      description: 'Explorar nossos produtos',
      price: 'Preço',
      stock: 'Estoque'
    },
    calendar: {
      title: 'Calendário',
      description: 'Agendar um horário',
      bookAppointment: 'Reservar'
    },
    services: {
      title: 'Serviços',
      description: 'Nossos serviços',
      learnMore: 'Saiba mais'
    },
    gallery: {
      title: 'Galeria',
      description: 'Ver nossa galeria'
    },
    realestate: {
      title: 'Imóveis',
      description: 'Explorar imóveis',
      price: 'Preço',
      surface: 'Área',
      rooms: 'Quartos',
      location: 'Localização',
      type: 'Tipo de imóvel',
      status: 'Status',
      features: 'Características'
    }
  },
  pages: {
    home: {
      hero: {
        title: "Inteligência Artificial",
        subtitle: "a serviço dos seus usuários",
        description: "Descubra a nova geração de chatbots alimentados por IA. Aproveite a qualificação e captura de leads fluida através de nossas ferramentas únicas no mercado.",
        cta: {
          primary: 'Começar gratuitamente',
          secondary: 'Ver preços',
          dashboard: 'Acessar meu Dashboard'
        }
      },
      demo: {
        title: 'Descubra nossa Demo',
        description: 'Teste nosso chatbot ao vivo e descubra todas as suas funcionalidades'
      },
      leadDetection: {
        title: 'Detecção e captura',
        highlight: 'automática',
        suffix: 'de leads',
        description: 'Capture o máximo de dados e entenda profundamente as necessidades dos seus visitantes através de nossas ferramentas avançadas de análise.',
        features: {
          emails: {
            title: 'Detecção de Emails',
            description: 'Captura automática de endereços de email mencionados nas conversas'
          },
          phones: {
            title: 'Detecção de Telefones',
            description: 'Reconhecimento inteligente de números de telefone nas conversas'
          },
          notifications: {
            title: 'Notificações Instantâneas',
            description: 'Seja alertado em tempo real de cada novo lead detectado'
          },
          crm: {
            title: 'Integrações CRM',
            description: 'Sincronização automática com Salesforce, HubSpot e muito mais'
          }
        }
      },
      design: {
        title: 'Ultra',
        highlight: 'personalização',
        suffix: 'do design do seu bot!',
        description: 'Crie um chatbot único que reflita perfeitamente sua identidade visual. Nossa interface intuitiva permite personalizar cada aspecto da aparência.',
        features: {
          colors: 'Gradientes de cores personalizáveis',
          messages: 'Personalização de mensagens e textos',
          themes: 'Temas claros e escuros'
        }
      },
      ai: {
        title: 'Uma configuração',
        highlight: 'IA fluida',
        suffix: 'e estruturada',
        description: 'Configure seu assistente de IA em poucos cliques. Nossa interface intuitiva guia você através de cada etapa para uma eficiência ideal.',
        features: {
          personalization: 'Personalização avançada de IA',
          security: 'Segurança e confidencialidade garantidas',
          multilingual: 'Suporte multilíngue'
        }
      },
      miniApps: {
        title: '',
        highlight: 'Mini Apps',
        suffix: 'para todas as suas necessidades!',
        description: 'Ofereça uma experiência única e interativa aos seus clientes. Não precisa mudar de página, tudo está integrado diretamente no chat!',
        apps: {
          calendar: {
            title: 'Calendário',
            description: 'Agendamento integrado'
          },
          products: {
            title: 'Produtos',
            description: 'Catálogo interativo'
          },
          services: {
            title: 'Serviços',
            description: 'Apresentação dinâmica'
          },
          gallery: {
            title: 'Galeria',
            description: 'Fotos e vídeos'
          }
        }
      },
      multilingual: {
        title: 'Suporte',
        highlight: 'Multilíngue',
        suffix: 'Integrado',
        description: 'Comunique-se com seus clientes em seu idioma. Nosso chatbot se adapta automaticamente ao idioma dos seus visitantes.',
        features: {
          translation: 'Tradução completa',
          choice: 'Dê escolha aos seus usuários',
          configuration: 'Configuração Simples'
        }
      },
      analytics: {
        title: 'Aprenda sobre seus',
        highlight: 'usuários',
        description: 'Capture o máximo de dados e entenda profundamente as necessidades dos seus visitantes.',
        features: {
          stats: {
            title: 'Estatísticas Avançadas',
            description: 'Analise em detalhes o comportamento dos seus visitantes e otimize sua estratégia.'
          },
          segments: {
            title: 'Segmentação de Usuários',
            description: 'Identifique seus segmentos de usuários mais relevantes.'
          }
        }
      },
      linktree: {
        title: 'Chega de',
        highlight: 'LinkTree',
        suffix: '!',
        description: 'Capture mais leads, faça sua marca ou personal branding falar, literalmente! Dinamize seu site e retenha seus usuários.',
        features: {
          sharing: {
            title: 'Compartilhamento Interativo',
            description: 'Compartilhe seus links de forma interativa e envolvente com seus visitantes.'
          },
          conversion: {
            title: 'Conversão Otimizada',
            description: 'Aumente suas taxas de conversão através de uma experiência única do usuário.'
          },
          analytics: {
            title: 'Analytics Detalhado',
            description: 'Acompanhe e analise o desempenho dos seus links compartilhados.'
          }
        }
      },
      integrations: {
        title: 'Poderosas',
        highlight: 'Integrações',
        suffix: 'ao seu alcance',
        description: 'Conecte suas ferramentas e serviços favoritos com facilidade. Nossa plataforma se integra com as soluções empresariais mais populares.',
        badge: 'Plataforma Tudo-em-Um',
        subtitle: 'a seu serviço',
        features: {
          crm: {
            title: 'Integração CRM',
            description: 'Sincronize automaticamente seus leads com Salesforce, HubSpot e outros'
          },
          analytics: {
            title: 'Integração Analytics',
            description: 'Acompanhe conversões e comportamento do usuário com ferramentas populares de análise'
          },
          marketing: {
            title: 'Integração Ferramentas Marketing',
            description: 'Conecte-se às suas plataformas de email marketing e automação'
          },
          automation: {
            title: 'Automação de Fluxo de Trabalho',
            description: 'Crie automações poderosas com Zapier, Make e outras ferramentas de workflow'
          },
          web: {
            title: 'Integração Web',
            description: 'Integre facilmente com seu site e aplicações web'
          }
        }
      },
      ecommerce: {
        title: 'Solução',
        highlight: 'E-commerce',
        suffix: 'completa',
        description: 'Gerencie sua loja online sem esforço. Da gestão de produtos ao acompanhamento de pedidos, tudo que você precisa em um só lugar.',
        features: {
          products: {
            title: 'Gestão de Produtos',
            description: 'Gerencie e sincronize facilmente seu catálogo de produtos'
          },
          orders: {
            title: 'Acompanhamento de Pedidos',
            description: 'Acompanhamento de pedidos em tempo real'
          },
          cart: {
            title: 'Recuperação de Carrinho',
            description: 'Recuperação automatizada de carrinhos abandonados'
          },
          promotions: {
            title: 'Promoções',
            description: 'Crie e gerencie campanhas promocionais'
          }
        }
      }
    },
    pricing: {
      title: 'Escolha seu plano',
      subtitle: 'Botmaker',
      description: 'Planos adaptados a todas as suas necessidades',
      monthly: 'Mensal',
      yearly: 'Anual',
      free: 'Gratuito',
      starter: 'Starter',
      professional: 'Profissional',
      enterprise: 'Empresa',
      features: {
        ai: 'Configurações de IA',
        design: 'Configurações de Design',
        widget: 'Códigos de integração',
        integrations: 'Todas as mini-apps',
        gallery: 'Galeria de fotos',
        conversations: 'Conversas',
        stats: 'Estatísticas'
      },
      billing_info: 'Todos os preços são em euros sem impostos. O faturamento é',
      conversations: {
        title: 'Como funcionam as conversas?',
        description: 'Uma conversa começa com a primeira mensagem do usuário e termina após um período de inatividade. Independentemente do número de trocas (2 ou 50 mensagens), conta como uma única conversa. Cada plano inclui um número definido de conversas por mês, permitindo que você interaja extensivamente com seus visitantes.'
      },
      custom: {
        title: 'Precisa de um plano personalizado?',
        description: 'Quer um volume maior de conversas ou um chatbot 100% personalizado? Nossa equipe está à disposição para entender suas necessidades e propor uma solução sob medida.',
        cta: 'Agendar uma reunião'
      }
    }
  },
  footer: {
    product: {
      title: 'Produto',
      features: 'Funcionalidades',
      pricing: 'Preços',
      guide: 'Guia',
      miniApps: 'Mini Apps',
      integrations: 'Integrações'
    },
    resources: {
      title: 'Recursos',
      documentation: 'Documentação',
      blog: 'Blog'
    },
    company: {
      title: 'Empresa',
      about: 'Sobre',
      contact: 'Contato',
      careers: 'Carreiras',
      partners: 'Parceiros'
    },
    legal: {
      title: 'Legal',
      terms: 'Termos de Serviço',
      privacy: 'Política de Privacidade',
      cookies: 'Cookies',
      mentions: 'Aviso Legal'
    },
    copyright: '© 2025 Botmaker Agency. Todos os direitos reservados.'
  }
};